export enum StudentFields {
    GENDER = 'gender',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    BIRTHDAY = 'birthday',
    ADDRESS = 'address',
    PAYMENT = 'payment',
    HAS_LOGIN = 'hasLogin',
    IS_ACTIVE = 'isActive',
    DEACTIVATED_AT = 'deactivatedAt',
    CONTACT_INFORMATION = 'contactInformation',
    CUSTOM_ID = 'customId',
    CUSTOM_ID_SCHEME = 'customIdScheme',
    ACCOUNTING_REF = 'accountingRef',

    INSTITUTION = 'institution',
    PARENTS = 'parents',
    END_OF_LESSONS = 'endOfLessons',
    END_OF_AFTER_SCHOOL_CARE = 'endOfAfterSchoolCare',
    REGISTRATION_STATE = 'registrationState',
    ACTIVITY_REGISTRATION = 'activityRegistration',
    INSTITUTION_ACTIVITY_SIGNUP = 'institutionActivitySignup',
    TIMESLOTS = 'timeslots',
    CLASS = 'class',
    SPECIAL_INFORMATION = 'specialInformation',
    STATE = 'state',
    SUBJECTS = 'subjects',
    IS_CUSTOMER = 'isCustomer',
    PAUSED_UNTIL = 'pausedUntil',
    TAGS = 'tags',
    SUBMISSION = 'submission',
    AVAILABILITIES = 'availabilities',

    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',

    DEACTIVATE_AT = 'deactivateAt',
    ACTIVATE_AT = 'activateAt',

    NO_EARLY_WARNING_MAILS = 'noEarlyWarningMails',
    NO_FEEDBACK_REQUESTS = 'noFeedbackRequests',

    /** Virtual fields */
    INVENTORY = 'inventory',
}
